import { useEffect, useState, useMemo, useCallback, useRef } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Row,
  Button,
} from "reactstrap";
import { Link } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";
import Loader from "../../Components/Common/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { listOrderReports, listOrderStatus, listPaymentMethod } from "./_requests";
import { useDownloadExcel } from 'react-export-table-to-excel'
import { formatDate } from "../../helpers/FunctionHelpers";

const OrderReports = () => {
  const tableRef = useRef<HTMLTableElement>(null)
  const [orderList, setOrderList] = useState<any>([]);
  const [orderStatus, setOrderStatus] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const initialFilterData = {
    orderstatus: 0,
    paymentmethod: 0,
  };
  const [filterData, setFilterData] = useState(initialFilterData);
  const [dateRange, setDateRange] = useState<Date[] | undefined>(undefined);


  // Handle filter changes for Payment Method and Order Status
  const handleFilterChange = (e: any) => {
    const { name, value } = e.target;
    setFilterData((prevData) => ({
      ...prevData,
      [name]: Number(value)
    }));
  };

  const handleDateChange = (selectedDates: Date[]) => {
    const formattedDates = selectedDates.map((date) => {
      return date.toISOString().split("T")[0]; // Format to YYYY-MM-DD
    });
    setDateRange(selectedDates); // Update dateRange with selected Date objects
    console.log("Formatted Dates for DB:", formattedDates);
  };

  // Reset filters to initial state
  const handleReset = () => {
    setFilterData(initialFilterData);
    setDateRange(undefined);
  };

  console.log("dateRange", dateRange);
  const [orderType, setOrderType] = useState(1); // default to 1 (Product Orders)
  const handleFilter = () => {
    fetchOrders(orderType); // re-fetch based on selected type
  };

  useEffect(() => {
    fetchOrders(orderType);
    listOrderStatus().then((res: any) => setOrderStatus(res.data));
    listPaymentMethod().then((res: any) => setPaymentMethod(res.data));
  }, [orderType]);

  const fetchOrders = (type: number) => {
    const data = {
      orderStatus: filterData.orderstatus,
      paymentMethod: filterData.paymentmethod,
      dateRange,
      type, // pass type to API
    };
    listOrderReports(data).then((res: any) => {
      setOrderList(res.data);
    });
  };


  // Column
  const columns = useMemo(() => {
    if (orderType === 2) {
      return [
        { 
          header: "S.No", 
          accessorKey: "s_no", 
          cell: (cell: any) => {
            const { pageIndex, pageSize } = cell.table.getState().pagination;
            return <span>{pageIndex * pageSize + cell.row.index + 1}</span>;
          } 
        },
        { header: "Subscription ID", accessorKey: "subscription_id" },
        { header: "User", accessorKey: "users.name" },
        { header: "Plan", accessorKey: "subscription_plan" },
        { header: "Next Billing Date", accessorKey: "next_billing_date" },
        // Add other subscription-specific fields
      ];
    }

    return [
      { 
        header: "S.No", 
        accessorKey: "s_no", 
        cell: (cell: any) => {
          const { pageIndex, pageSize } = cell.table.getState().pagination;
          return <span>{pageIndex * pageSize + cell.row.index + 1}</span>;
        } 
      },
      {
        header: "Order Id",
        accessorKey: "order_id",
        cell: (cell: any) => {
          const date = cell.row.original.order_date;
          return (
            <>
              <Link to={`/orders/view/${cell.row.original.id}`} className="fw-medium link-primary">
                {cell.getValue()}
              </Link>
              <div>
                {formatDate(date)},

              </div>
            </>
          );
        },
      },
      { header: "User", accessorKey: "users.name" },
      { header: "Amount", accessorKey: "total_amount" },
      { header: "Payment Method", accessorKey: "paymentMethod.name" },
      {
        header: "Delivery Status",
        accessorKey: "orderStatus.id",
        cell: (cell: any) => {
          const statusName = cell.row.original.orderStatus?.name;
          return (
            <span className="badge text-uppercase bg-primary-subtle text-primary">
              {statusName}
            </span>
          );
        },
      },
    ];
  }, [orderType]);


  var DatefileName = new Date()
  var fileName =
    DatefileName.getFullYear() + '-' + (DatefileName.getMonth() + 1) + '-' + DatefileName.getDate()


  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: `Order_Report_${fileName}`,
    sheet: 'report',
  })
  document.title = " Paal Dappa | Admin panel";
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Orders" pageTitle="Paal Dappa" />
        <Row>
          <Col lg={12}>
            <Card id="orderList">
              <CardHeader className="card-header border-0">
                <Row className="align-items-center gy-3">
                  <div className="col-sm">
                    <h5 className="card-title mb-0">Order Report</h5>
                  </div>
                  <div className="col-sm-auto">
                    <Button
                      color="primary"
                      onClick={onDownload}
                    >
                      Download
                    </Button>
                  </div>
                </Row>
              </CardHeader>

              <CardBody className="pt-0">
                <Col sm="4" className="mb-2">
                  <label htmlFor="orderType">Order Type</label>
                  <select
                    id="orderType"
                    className="form-select"
                    value={orderType}
                    onChange={(e) => setOrderType(Number(e.target.value))}
                  >
                    <option value={1}>Product Orders</option>
                    <option value={2}>Subscription Orders</option>
                  </select>
                </Col>

                <Row className="align-items-center mb-3">
                  <Col sm="4" className="mb-2">
                    <label htmlFor="paymentMethod">Payment Method</label>
                    <select
                      id="paymentMethod"
                      name="paymentmethod"
                      className="form-select"
                      value={filterData.paymentmethod}
                      onChange={handleFilterChange}

                    >
                      <option value={0}>All</option>
                      {paymentMethod.map((item: any) => {
                        return (
                          <option value={item.id} key={item.id}>
                            {item.name}
                          </option>
                        );
                      })}

                    </select>
                  </Col>

                  <Col sm="4" className="mb-2">
                    <label htmlFor="orderDateRange">Order Date Range</label>
                    <div className="input-group">
                      <Flatpickr
                        className="form-control border-0 dash-filter-picker shadow"
                        placeholder="Select date range"
                        options={{
                          mode: "range",
                          dateFormat: "d M, Y",
                        }}
                        value={dateRange} // Convert to Date objects for Flatpickr
                        onChange={handleDateChange}
                      />
                      <div className="input-group-text">
                        <i className="ri-calendar-2-line"></i>
                      </div>
                    </div>
                  </Col>

                  <Col sm="4" className="mb-2">
                    <label htmlFor="deliveryStatus">Order Status</label>
                    <select
                      id="deliveryStatus"
                      name="orderstatus"
                      className="form-select"
                      value={filterData.orderstatus}
                      onChange={handleFilterChange}
                    >
                      <option value={0}>All</option>
                      {orderStatus.map((item: any) => {
                        return (
                          <option value={item.id} key={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                    </select>
                  </Col>
                </Row>
                <Row className="align-items-center mb-2">
                  <Col sm="4">
                    <button className="btn btn-primary w-100 mb-2" onClick={handleFilter}>Filter</button>
                  </Col>
                  <Col sm="4">
                    <button className="btn btn-primary w-100 mb-2" onClick={handleReset}>Reset</button>
                  </Col>
                </Row>

                <div>
                  {orderList?.length ? (

                    <TableContainer
                      columns={columns}
                      ref={tableRef}
                      data={orderList || []}
                      customPageSize={10}
                      divClass="table-responsive table-card mb-1 mt-0"
                      tableClass="align-top table-bordered align-top table-nowrap mb-0"
                      theadClass="table-light fw-bold"
                    />
                  ) : (
                    <p className="fw-bold text-center">No Results Found</p>
                  )}
                </div>

                <ToastContainer closeButton={false} limit={1} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default OrderReports;
